/**
 * Kalkulator spalania kalorii (DNZ-367).
 *
 * Skrypt niczego nie dorenderowuje - wszystkie aktywności, tabelka przykładowa
 * i teksty stoją w źródle HTML. Tutaj dzieje się tylko przeliczanie na bieżąco,
 * przełączanie stanu A/B panelu wyniku i zamiana <select> z 83 pozycjami
 * na pole wyboru z wyszukiwaniem.
 *
 * Wartości MET czytamy z atrybutów data-* opcji, więc tabela z pliku
 * konfiguracyjnego jest jedynym źródłem prawdy. Wzory i zaokrąglenie muszą
 * dawać ten sam wynik co metody kcal_total() / kcal_net() w klasie bloku.
 *
 * Vanilla JS, bez jQuery.
 */
(function () {
	'use strict';

	var COMBINING_MARKS = new RegExp('[\\u0300-\\u036f]', 'g');
	var NBSP = '\u00a0'; // spacja nierozdzielająca, tak jak w number_format() po stronie PHP

	/**
	 * Zwija tekst do ASCII, żeby "cwiczenia" znalazło "ćwiczenia".
	 */
	function fold(value) {
		return String(value)
			.toLowerCase()
			.normalize('NFD')
			.replace(COMBINING_MARKS, '')
			.replace(/ł/g, 'l'); // ł nie ma dekompozycji NFD
	}

	/**
	 * Liczba całkowita z separatorem tysięcy - odpowiednik decimal() w PHP.
	 */
	function formatNumber(value) {
		return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
	}

	function toNumber(value) {
		if (value === null || value === '' || typeof value === 'undefined') {
			return NaN;
		}
		var parsed = parseFloat(String(value).replace(',', '.'));
		return isNaN(parsed) ? NaN : parsed;
	}

	/**
	 * Zaokrąglenie w dół do pełnych kilokalorii - odpowiednik floor_kcal() w PHP.
	 *
	 * round() przed floor() ucina śmieci zmiennoprzecinkowe: 1.3 * 60 * 1 to
	 * 77.99999999999999, czyli 77 kcal zamiast 78.
	 */
	function floorKcal(value) {
		return Math.max(0, Math.floor(Math.round(value * 1e6) / 1e6));
	}

	/**
	 * Pozycja wartości na torze suwaka - odpowiednik fill_percent() w PHP.
	 */
	function fillPercent(value, min, max) {
		if (!(max > min)) {
			return 0;
		}
		return Math.min(100, Math.max(0, ((value - min) / (max - min)) * 100));
	}

	// Wzór z sekcji 3.1 dokumentacji. Zaokrąglenie zawsze w dół (sekcja 3.5).
	function kcalTotal(met, weight, minutes) {
		return floorKcal(met * weight * (minutes / 60));
	}

	function kcalNet(met, weight, minutes) {
		return floorKcal(Math.max(0, met - 1) * weight * (minutes / 60));
	}

	function initCalculator(root) {
		var select = root.querySelector('[data-role="activity"]');
		var weightNumber = root.querySelector('[data-role="weight-number"]');
		var weightRange = root.querySelector('[data-role="weight-range"]');
		var weightFill = root.querySelector('[data-role="weight-fill"]');
		var weightError = root.querySelector('[data-role="weight-error"]');
		var minutesNumber = root.querySelector('[data-role="minutes-number"]');
		var minutesRange = root.querySelector('[data-role="minutes-range"]');
		var minutesFill = root.querySelector('[data-role="minutes-fill"]');
		var minutesError = root.querySelector('[data-role="minutes-error"]');
		var intensityField = root.querySelector('[data-field="intensity"]');
		var intensityHint = root.querySelector('[data-role="intensity-hint"]');
		var activityNote = root.querySelector('[data-role="activity-note"]');
		var emptyState = root.querySelector('[data-state="empty"]');
		var valueState = root.querySelector('[data-state="value"]');
		var totalEl = root.querySelector('[data-role="total"]');
		var netEl = root.querySelector('[data-role="net"]');
		var mealLink = root.querySelector('[data-role="meal-link"]');
		var liveEl = root.querySelector('[data-role="live"]');

		if (!select || !weightNumber || !minutesNumber || !emptyState || !valueState) {
			return;
		}

		var intensityInputs = Array.prototype.slice.call(root.querySelectorAll('[data-role="intensity"]'));
		var sampleRows = Array.prototype.slice.call(root.querySelectorAll('[data-role="sample-row"]'));

		var limits = {
			weightMin: toNumber(root.getAttribute('data-weight-min')),
			weightMax: toNumber(root.getAttribute('data-weight-max')),
			minutesMin: toNumber(root.getAttribute('data-minutes-min')),
			minutesMax: toNumber(root.getAttribute('data-minutes-max'))
		};

		var thresholds = {
			lowNet: toNumber(root.getAttribute('data-low-net')),
			lowMet: toNumber(root.getAttribute('data-low-met')),
			longMinutes: toNumber(root.getAttribute('data-long-minutes'))
		};

		// Progi mostu do posiłku - z pliku konfiguracyjnego, nie z kodu.
		var mealBrackets = {
			low: toNumber(root.getAttribute('data-meal-low')),
			mid: toNumber(root.getAttribute('data-meal-mid'))
		};

		// --- Aktywności i rodziny intensywności, czytane z opcji <select> ---

		var options = Array.prototype.slice.call(select.options);
		var byCode = {};
		var families = {};

		options.forEach(function (option) {
			var data = {
				code: option.value,
				label: option.textContent.trim(),
				met: toNumber(option.getAttribute('data-met')),
				family: option.getAttribute('data-family') || '',
				role: option.getAttribute('data-variant') || '',
				note: option.getAttribute('data-note') || '',
				group: option.parentNode && option.parentNode.label ? option.parentNode.label : '',
				option: option
			};

			byCode[data.code] = data;

			if (data.family && data.role) {
				families[data.family] = families[data.family] || {};
				families[data.family][data.role] = data.code;
			}
		});

		// Ostatni poprawny czas - tabelka przykładowa nie może zgubić wartości,
		// gdy użytkownik skasuje pole albo wpisze liczbę spoza zakresu.
		var lastMinutes = toNumber(minutesNumber.value);
		if (isNaN(lastMinutes)) {
			lastMinutes = limits.minutesMin;
		}

		/**
		 * Odczyt pola liczbowego: { value, empty, invalid }.
		 */
		function readField(input, min, max) {
			var raw = String(input.value).trim();

			if (raw === '') {
				return { value: null, empty: true, invalid: false };
			}

			var value = toNumber(raw);
			if (isNaN(value) || value < min || value > max) {
				return { value: null, empty: false, invalid: true };
			}

			return { value: value, empty: false, invalid: false };
		}

		function toggle(element, visible) {
			if (element) {
				element.hidden = !visible;
			}
		}

		// --- Panel wyniku ---------------------------------------------------

		function updateSamples(met, minutes) {
			sampleRows.forEach(function (row) {
				var weight = toNumber(row.getAttribute('data-weight'));
				var total = row.querySelector('[data-role="sample-total"]');
				var net = row.querySelector('[data-role="sample-net"]');

				if (isNaN(weight)) {
					return;
				}
				if (total) {
					total.textContent = formatNumber(kcalTotal(met, weight, minutes));
				}
				if (net) {
					net.textContent = formatNumber(kcalNet(met, weight, minutes));
				}
			});
		}

		/**
		 * Most do posiłku: odsyłacz z treścią zależną od wyniku, prowadzący
		 * wprost do kafla właściwego przedziału. Kotwice kafli mają numer
		 * przedziału na końcu (posilki-1, posilki-2, posilki-3); gdy takiej
		 * sekcji na stronie nie ma, zostaje odsyłacz do całej sekcji.
		 */
		function updateMeal(total) {
			if (!mealLink) {
				return;
			}

			var bracket = total <= mealBrackets.low ? 1 : (total <= mealBrackets.mid ? 2 : 3);
			var template = mealLink.getAttribute('data-meal-' + bracket) || '';

			if (!template) {
				toggle(mealLink, false);
				return;
			}

			mealLink.textContent = template.replace('{kcal}', formatNumber(total));

			var anchor = (mealLink.getAttribute('data-anchor') || '').replace(/^#/, '');
			if (anchor) {
				var card = document.getElementById(anchor + '-' + bracket);
				mealLink.setAttribute('href', '#' + (card ? anchor + '-' + bracket : anchor));
			}

			toggle(mealLink, true);
		}

		/**
		 * Komunikaty warunkowe: maksymalnie dwa naraz, w kolejności ważności.
		 * Stały komunikat o zegarku stoi zawsze i nie wlicza się do limitu.
		 */
		function updateMessages(activity, minutes, hasResult, net) {
			var candidates = [
				{ key: 'low-result', on: hasResult && !isNaN(thresholds.lowNet) && net < thresholds.lowNet },
				{ key: 'low-met', on: !isNaN(thresholds.lowMet) && activity && activity.met < thresholds.lowMet },
				{ key: 'long-session', on: !isNaN(thresholds.longMinutes) && minutes > thresholds.longMinutes }
			];

			var wrap = root.querySelector('.calories-burn-calculator__messages');
			var shown = 0;

			candidates.forEach(function (candidate) {
				var element = root.querySelector('[data-message="' + candidate.key + '"]');
				if (!element) {
					return;
				}
				var visible = candidate.on && shown < 2;
				if (visible) {
					shown += 1;
				}
				toggle(element, visible);
			});

			// Klasa steruje odstępem: pusty blok komunikatów nie może rozpychać
			// przerwy między kalkulatorem a paskiem nawigacji.
			if (wrap) {
				wrap.classList.toggle('is-visible', shown > 0);
			}
		}

		function render() {
			var activity = byCode[select.value];
			if (!activity) {
				return;
			}

			var weight = readField(weightNumber, limits.weightMin, limits.weightMax);
			var minutes = readField(minutesNumber, limits.minutesMin, limits.minutesMax);

			toggle(weightError, weight.invalid);
			toggle(minutesError, minutes.invalid || minutes.empty);

			if (minutes.value !== null) {
				lastMinutes = minutes.value;
			}

			// Suwaki i pola liczbowe to jedna wartość w dwóch kontrolkach.
			if (weightRange) {
				weightRange.classList.toggle('is-empty', weight.value === null);
				if (weight.value !== null) {
					weightRange.value = Math.min(limits.weightMax, Math.max(limits.weightMin, Math.round(weight.value)));
					weightRange.setAttribute('aria-valuetext', weight.value + ' kg');
				} else {
					weightRange.setAttribute('aria-valuetext', 'nie podano');
				}
			}
			if (weightFill) {
				// Pusta masa ciała = pusty tor, żeby nic nie sugerowało wyniku.
				weightFill.style.width = weight.value === null
					? '0%'
					: fillPercent(weight.value, limits.weightMin, limits.weightMax) + '%';
			}
			if (minutesRange && minutes.value !== null) {
				minutesRange.value = Math.min(limits.minutesMax, Math.max(limits.minutesMin, Math.round(minutes.value)));
			}
			if (minutesFill) {
				minutesFill.style.width = fillPercent(lastMinutes, limits.minutesMin, limits.minutesMax) + '%';
			}

			updateSamples(activity.met, lastMinutes);

			var hasResult = weight.value !== null && minutes.value !== null;
			var total = 0;
			var net = 0;

			if (hasResult) {
				total = kcalTotal(activity.met, weight.value, minutes.value);
				net = kcalNet(activity.met, weight.value, minutes.value);

				if (totalEl) {
					totalEl.textContent = formatNumber(total);
				}
				if (netEl) {
					netEl.textContent = formatNumber(net);
				}
				updateMeal(total);
			}

			toggle(emptyState, !hasResult);
			toggle(valueState, hasResult);

			updateMessages(activity, lastMinutes, hasResult, net);

			if (liveEl) {
				liveEl.textContent = hasResult
					? 'Wynik: ' + total + ' kcal, w tym ponad spoczynek ' + net + ' kcal.'
					: '';
			}
		}

		// --- Intensywność ---------------------------------------------------

		function syncIntensity() {
			var activity = byCode[select.value];
			if (!activity || !intensityField) {
				return;
			}

			var variants = activity.family ? (families[activity.family] || {}) : {};
			var hasFamily = !!activity.family;

			intensityField.disabled = !hasFamily;

			intensityInputs.forEach(function (input) {
				var code = variants[input.value] || '';
				input.disabled = !hasFamily || code === '';
				input.checked = hasFamily && code !== '' && code === activity.code;
			});

			if (intensityHint) {
				intensityHint.textContent = hasFamily
					? (intensityHint.getAttribute('data-hint-default') || '')
					: (intensityHint.getAttribute('data-hint-locked') || '');
			}

			if (activityNote) {
				activityNote.textContent = activity.note;
				toggle(activityNote, !!activity.note);
			}
		}

		intensityInputs.forEach(function (input) {
			input.addEventListener('change', function () {
				var activity = byCode[select.value];
				if (!activity || !activity.family) {
					return;
				}

				var code = (families[activity.family] || {})[input.value] || '';
				if (!code || !byCode[code]) {
					return;
				}

				// Lista aktywności przestawia się na pozycję rodzeństwa, żeby nie
				// było stanu "na liście jedno, wynik z czegoś innego".
				select.value = code;
				if (typeof select.setDisplay === 'function') {
					select.setDisplay(byCode[code].label);
				}
				syncIntensity();
				render();
			});
		});

		select.addEventListener('change', function () {
			syncIntensity();
			render();
		});

		[weightNumber, minutesNumber].forEach(function (input) {
			input.addEventListener('input', render);
		});

		if (weightRange) {
			weightRange.addEventListener('input', function () {
				weightNumber.value = weightRange.value;
				render();
			});
		}

		if (minutesRange) {
			minutesRange.addEventListener('input', function () {
				minutesNumber.value = minutesRange.value;
				render();
			});
		}

		enhanceSelect(root, select, byCode);
		syncIntensity();
		render();
	}

	/**
	 * Zamienia <select> z 83 pozycjami na pole tekstowe z filtrowaną listą.
	 * Oryginalny <select> zostaje w DOM (i w źródle HTML), tylko go chowamy -
	 * bez JS użytkownik dostaje zwykłą, działającą listę wyboru.
	 */
	function enhanceSelect(root, select, byCode) {
		var listId = select.id + '-listbox';
		var inputId = select.id + '-combo';

		var wrap = document.createElement('div');
		wrap.className = 'calories-burn-calculator__combo';

		var input = document.createElement('input');
		input.type = 'text';
		input.id = inputId;
		input.className = 'calories-burn-calculator__combo-input';
		input.setAttribute('role', 'combobox');
		input.setAttribute('autocomplete', 'off');
		input.setAttribute('aria-expanded', 'false');
		input.setAttribute('aria-autocomplete', 'list');
		input.setAttribute('aria-controls', listId);
		input.placeholder = 'Zacznij pisać, np. rower';

		var toggleBtn = document.createElement('button');
		toggleBtn.type = 'button';
		toggleBtn.className = 'calories-burn-calculator__combo-toggle';
		toggleBtn.setAttribute('tabindex', '-1');
		toggleBtn.setAttribute('aria-label', 'Pokaż listę aktywności');

		var list = document.createElement('ul');
		list.id = listId;
		list.className = 'calories-burn-calculator__combo-list';
		list.setAttribute('role', 'listbox');
		list.hidden = true;

		var empty = document.createElement('li');
		empty.className = 'calories-burn-calculator__combo-empty';
		empty.textContent = 'Brak aktywności pasujących do wpisanego tekstu.';
		empty.hidden = true;

		var items = [];
		var headers = [];

		Array.prototype.forEach.call(select.children, function (child) {
			if (child.tagName !== 'OPTGROUP') {
				return;
			}

			var header = document.createElement('li');
			header.className = 'calories-burn-calculator__combo-group';
			header.setAttribute('role', 'presentation');
			header.textContent = child.label;
			list.appendChild(header);

			var groupItems = [];

			Array.prototype.forEach.call(child.children, function (option) {
				var item = document.createElement('li');
				item.className = 'calories-burn-calculator__combo-option';
				item.id = listId + '-' + option.value;
				item.setAttribute('role', 'option');
				item.setAttribute('aria-selected', option.selected ? 'true' : 'false');
				item.setAttribute('data-value', option.value);
				item.textContent = option.textContent.trim();
				item.search = fold(option.textContent + ' ' + child.label);
				list.appendChild(item);
				items.push(item);
				groupItems.push(item);
			});

			header.groupItems = groupItems;
			headers.push(header);
		});

		list.appendChild(empty);

		select.parentNode.insertBefore(wrap, select);
		wrap.appendChild(input);
		wrap.appendChild(toggleBtn);
		wrap.appendChild(list);
		wrap.appendChild(select);

		select.hidden = true;

		var label = root.querySelector('label[for="' + select.id + '"]');
		if (label) {
			label.setAttribute('for', inputId);
		}

		var activeIndex = -1;

		function visibleItems() {
			return items.filter(function (item) {
				return !item.hidden;
			});
		}

		function setDisplay(text) {
			input.value = text;
			items.forEach(function (item) {
				item.setAttribute('aria-selected', item.getAttribute('data-value') === select.value ? 'true' : 'false');
			});
		}

		// Udostępniamy zmianę etykiety na zewnątrz - przełącznik intensywności
		// podmienia wybór i musi odświeżyć to, co widzi użytkownik.
		select.setDisplay = setDisplay;

		function setActive(index) {
			var visible = visibleItems();
			items.forEach(function (item) {
				item.classList.remove('is-active');
			});
			activeIndex = index;

			if (index < 0 || index >= visible.length) {
				input.removeAttribute('aria-activedescendant');
				return;
			}

			var item = visible[index];
			item.classList.add('is-active');
			input.setAttribute('aria-activedescendant', item.id);

			var top = item.offsetTop;
			var bottom = top + item.offsetHeight;
			if (top < list.scrollTop) {
				list.scrollTop = top;
			} else if (bottom > list.scrollTop + list.clientHeight) {
				list.scrollTop = bottom - list.clientHeight;
			}
		}

		function filter(query) {
			var needle = fold(query.trim());
			var matches = 0;

			items.forEach(function (item) {
				var visible = needle === '' || item.search.indexOf(needle) !== -1;
				item.hidden = !visible;
				if (visible) {
					matches += 1;
				}
			});

			headers.forEach(function (header) {
				header.hidden = !header.groupItems.some(function (item) {
					return !item.hidden;
				});
			});

			empty.hidden = matches > 0;
			setActive(matches > 0 ? 0 : -1);
		}

		function open() {
			if (!list.hidden) {
				return;
			}
			list.hidden = false;
			input.setAttribute('aria-expanded', 'true');

			var current = items.filter(function (item) {
				return item.getAttribute('data-value') === select.value;
			})[0];
			if (current) {
				list.scrollTop = Math.max(0, current.offsetTop - list.clientHeight / 2);
			}
		}

		function close(restore) {
			list.hidden = true;
			input.setAttribute('aria-expanded', 'false');
			input.removeAttribute('aria-activedescendant');
			setActive(-1);
			if (restore !== false) {
				filter('');
				setDisplay(byCode[select.value] ? byCode[select.value].label : '');
			}
		}

		function choose(item) {
			if (!item) {
				return;
			}
			select.value = item.getAttribute('data-value');
			setDisplay(byCode[select.value] ? byCode[select.value].label : item.textContent);
			close();
			select.dispatchEvent(new Event('change', { bubbles: true }));
		}

		input.addEventListener('focus', function () {
			open();
			input.select();
		});

		input.addEventListener('input', function () {
			open();
			filter(input.value);
		});

		input.addEventListener('keydown', function (event) {
			var visible = visibleItems();

			if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
				event.preventDefault();
				open();
				if (!visible.length) {
					return;
				}
				var next = event.key === 'ArrowDown' ? activeIndex + 1 : activeIndex - 1;
				if (next < 0) {
					next = visible.length - 1;
				}
				if (next >= visible.length) {
					next = 0;
				}
				setActive(next);
				return;
			}

			if (event.key === 'Enter') {
				if (!list.hidden && activeIndex >= 0 && visible[activeIndex]) {
					event.preventDefault();
					choose(visible[activeIndex]);
				}
				return;
			}

			if (event.key === 'Escape' && !list.hidden) {
				event.preventDefault();
				close();
			}
		});

		list.addEventListener('mousedown', function (event) {
			// mousedown, nie click - blur pola nie zdąży zamknąć listy.
			var item = event.target.closest('.calories-burn-calculator__combo-option');
			if (item) {
				event.preventDefault();
				choose(item);
			}
		});

		toggleBtn.addEventListener('click', function () {
			if (list.hidden) {
				// open() jawnie, bo po zamknięciu listy fokus zostaje w polu
				// i samo input.focus() nie odpaliłoby zdarzenia focus.
				input.focus();
				open();
			} else {
				close();
			}
		});

		document.addEventListener('click', function (event) {
			if (!wrap.contains(event.target) && !list.hidden) {
				close();
			}
		});

		wrap.addEventListener('focusout', function (event) {
			if (!wrap.contains(event.relatedTarget) && !list.hidden) {
				close();
			}
		});

		setDisplay(byCode[select.value] ? byCode[select.value].label : '');
	}

	/**
	 * Nawigacja kotwicowa dokleja się pod header motywu i jedzie z czytelnikiem
	 * do końca strony.
	 *
	 * Pozycję przełącza skrypt, a nie position: sticky, bo sticky przestaje
	 * działać na końcu sekcji kalkulatora - pasek odjeżdżałby razem z tabelą
	 * aktywności, zamiast towarzyszyć dalszym sekcjom strony.
	 *
	 * Wysokość headera czytamy z dolnej krawędzi jego prostokąta przy każdym
	 * przewinięciu: zanim doładują się fonty i logo, bywa inna niż na starcie.
	 */
	function initStickyNav(root) {
		var nav = root.querySelector('[data-role="nav"]');
		if (!nav) {
			return;
		}

		var header = document.querySelector('.site-header');
		var spacer = document.createElement('div');
		spacer.className = 'calories-burn-calculator__nav-spacer';
		spacer.hidden = true;
		nav.parentNode.insertBefore(spacer, nav);

		var isFixed = false;
		var ticking = false;

		// Scrollspy: linki nawigacji i sekcje, do których prowadzą. Kotwice
		// spoza strony (np. sekcja jeszcze nieopublikowana) dają null i są
		// po prostu pomijane.
		var list = nav.querySelector('ul');
		var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
		var targets = links.map(function (link) {
			var id = link.getAttribute('href').slice(1);
			return id ? document.getElementById(id) : null;
		});
		var activeIndex = -1;

		function headerOffset() {
			if (!header) {
				return 0;
			}
			var position = window.getComputedStyle(header).position;
			if (position !== 'sticky' && position !== 'fixed') {
				return 0;
			}
			var rect = header.getBoundingClientRect();
			return rect.top <= 0 ? Math.max(0, Math.round(rect.bottom)) : 0;
		}

		/**
		 * Przewija pasek w poziomie tak, żeby aktywna pigułka była widoczna.
		 * Dotyczy tylko wąskich ekranów, gdzie lista się nie mieści.
		 */
		function keepVisible(link) {
			if (!list || list.scrollWidth <= list.clientWidth) {
				return;
			}

			// Liczymy na prostokątach, a nie na offsetLeft: przy pozycji stałej
			// offsetParent pigułki zmienia się na sam pasek i offsety
			// przestają odpowiadać przewijaniu listy.
			var item = link.parentNode.getBoundingClientRect();
			var box = list.getBoundingClientRect();
			var margin = 16;

			if (item.left < box.left + margin) {
				list.scrollLeft += item.left - box.left - margin;
			} else if (item.right > box.right - margin) {
				list.scrollLeft += item.right - box.right + margin;
			}
		}

		/**
		 * Aktywna jest ostatnia sekcja, której górna krawędź minęła linię tuż
		 * pod paskiem. Na samym dole strony wygrywa sekcja ostatnia - inaczej
		 * krótka sekcja końcowa nigdy nie doszłaby do tej linii.
		 */
		function updateActive(offset) {
			if (!links.length) {
				return;
			}

			var line = offset + ( isFixed ? nav.getBoundingClientRect().height : 0 ) + 16;
			var current = -1;

			targets.forEach(function (target, index) {
				if (target && target.getBoundingClientRect().top <= line) {
					current = index;
				}
			});

			var atBottom = window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 2;
			if (atBottom) {
				for (var i = targets.length - 1; i >= 0; i--) {
					if (targets[i]) {
						current = i;
						break;
					}
				}
			}

			if (current === activeIndex) {
				return;
			}

			if (links[activeIndex]) {
				links[activeIndex].classList.remove('is-active');
				links[activeIndex].removeAttribute('aria-current');
			}

			activeIndex = current;

			if (links[activeIndex]) {
				links[activeIndex].classList.add('is-active');
				links[activeIndex].setAttribute('aria-current', 'true');
				keepVisible(links[activeIndex]);
			}
		}

		function update() {
			ticking = false;

			var offset = headerOffset();
			root.style.setProperty('--cbc-sticky-top', offset + 'px');

			// Punkt odniesienia to naturalne miejsce paska w potoku; kiedy pasek
			// jest przyklejony, trzyma je podstawka.
			var top = (isFixed ? spacer : nav).getBoundingClientRect().top;

			if (!isFixed && top <= offset) {
				// Do wysokości doliczamy margines, bo element poza potokiem
				// przestaje go wnosić i treść pod paskiem podskoczyłaby.
				var margin = parseFloat(window.getComputedStyle(nav).marginBottom) || 0;
				spacer.style.height = nav.getBoundingClientRect().height + margin + 'px';
				spacer.hidden = false;
				nav.classList.add('is-fixed');
				isFixed = true;
			} else if (isFixed && top > offset) {
				nav.classList.remove('is-fixed');
				spacer.hidden = true;
				isFixed = false;
			}

			updateActive(offset);
		}

		function onScroll() {
			if (!ticking) {
				ticking = true;
				window.requestAnimationFrame(update);
			}
		}

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll);
		window.addEventListener('load', onScroll);

		update();
	}

	function init() {
		var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-calories-burn]'));

		blocks.forEach(function (root) {
			initCalculator(root);
			initStickyNav(root);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
